import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css"

import { BrowserRouter, Route, Routes } from "react-router-dom"
import { Suspense, lazy } from "react"

import NotFound from "./pages/notFound"
const NewRcf = lazy(() => import("./components/v2/rcf/NewRcf"))
const PhotoVideoRcf = lazy(() => import("./components/v2/rcf/PhotoVideoRcf"))
const StoreReview = lazy(() => import("./components/v2/storeReview/StoreReview"))
const RcfConfirmation = lazy(() => import("./components/v2/rcf/RcfConfirmation"))
const Dashboard = lazy(() => import("./components/superAdmin/Dashboard"))

function RedirectToQuoli() {
  useEffect(() => {
    window.location.href = "https://quoli.io";
  }, []);

  return null;
}

function App() {

  // Hello
  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="*" element={<NotFound />} />
          {/* <Route path="/" element={<RedirectToQuoli />} /> */}
          <Route path="/rcf" element={<NewRcf />} />
          <Route path="/store-review" element={<StoreReview />} />
          <Route path="/RcfConfirmation" element={<RcfConfirmation />} />
          <Route path="/photoVideoRcf" element={<PhotoVideoRcf />} />
          <Route path="/super-admin/dashboard" element={<Dashboard />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
